import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import sessionStorage from 'redux-persist/lib/storage';
import { User } from "src/api/entities";


export interface GeneralData {
    email: string;
    password: string;
}


export interface LoggedUser {
    email: string;
    password: string;
}

export interface AccessState {
    generalData: GeneralData;
    loggedUser: User;
}

const initialLoggedUser: User = {
    email: '',
    password: ''
};

const initialState: AccessState = {
    generalData: {
        email: '',
        password: ''
    },
    loggedUser: initialLoggedUser
};

export const accessPersistedConfig = {
    key: 'access',
    storage: sessionStorage,
    whitelist: ['generalData', 'loggedUser'],
};

export const accessSlice = createSlice({
    name: "form",
    initialState: initialState,
    reducers: {
        login: (
            state,
            action: PayloadAction<User>
        ) => {
            state.loggedUser = action.payload;
        },
        logout: (
            state
        ) => {
            state.loggedUser = initialLoggedUser
        },
        saveValue(state, action: PayloadAction<{ key: keyof GeneralData; value: string }>) {
            state.generalData[action.payload.key] = action.payload.value;
        },
        resetGeneralData(state) {
            state.generalData = initialState.generalData;
        },
    },
});

export const { 
    login,
    logout,
    saveValue,
    resetGeneralData
 } = accessSlice.actions;

export const accessReducer = accessSlice.reducer;
